interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  inline?: boolean;
  className?: string;
}

export default function Spinner({ size = 'md', label = '読み込み中…', inline = false, className }: SpinnerProps) {
  const containerClass = inline ? 'spinner-inline' : 'spinner-box';
  const classes = className ? `${containerClass} ${className}` : containerClass;
  return (
    <div className={classes} role="status" aria-live="polite" aria-label={label || '読み込み中'}>
      <span className={`spinner__mark spinner__mark--${size}`} aria-hidden="true" />
      {label ? <span className="spinner__label">{label}</span> : null}
    </div>
  );
}
